import {
  GET_JACKPOT_PAYOUT_FOR_DRAWS,
  GET_JACKPOT_RESULTS_FOR_DRAW,
  GET_LATEST_JACKPOT_RESULTS,
  SEND_PLAYERS_DATA_FOR_JACKPOT
} from '@pbl/pbl-react-core/lib/models/games/types';
import { GamesService } from '@pbl/pbl-react-core/lib/services';
import { REQUEST, FAILURE, SUCCESS } from 'redux/action-type.util';

export const getLatestJackpotResult = (gameId: number, callbackFunc?: (args: any) => void) => async (dispatch: any) => {
  try {
    dispatch({
      type: REQUEST(GET_LATEST_JACKPOT_RESULTS),
      payload: null
    });
    const response = await GamesService.getLatestJackpotResultByGame(gameId);
    if (callbackFunc) {
      callbackFunc(response);
    } else {
      dispatch({
        type: SUCCESS(GET_LATEST_JACKPOT_RESULTS),
        payload: response
      });
    }
  } catch (error : any) {
    dispatch({
      type: FAILURE(GET_LATEST_JACKPOT_RESULTS),
      payload: error.payload ? error.payload : error
    });
  }
};

export const getJackpotResultByDraw = (gameId: number, drawId: number | string) => async (dispatch: any) => {
  try {
    dispatch({
      type: REQUEST(GET_JACKPOT_RESULTS_FOR_DRAW),
      payload: null
    });
    const response = await GamesService.getJackpotResultByGameAndDraw(gameId, drawId);
    dispatch({
      type: SUCCESS(GET_JACKPOT_RESULTS_FOR_DRAW),
      payload: response
    });
  } catch (error : any) {
    dispatch({
      type: FAILURE(GET_JACKPOT_RESULTS_FOR_DRAW),
      payload: error.payload ? error.payload : error
    });
  }
};

export const getNextJackpotResultByDraw = (gameId: number, drawId: number | string) => async (dispatch: any) => {
  try {
    dispatch({
      type: REQUEST('GET_NEXT_JACKPOT_RESULTS_FOR_DRAW'),
      payload: null
    });
    const response = await GamesService.getJackpotResultByGameAndDraw(gameId, drawId);
    dispatch({
      type: SUCCESS('GET_NEXT_JACKPOT_RESULTS_FOR_DRAW'),
      payload: response
    });
  } catch (error : any) {
    dispatch({
      type: FAILURE('GET_NEXT_JACKPOT_RESULTS_FOR_DRAW'),
      payload: error.payload ? error.payload : error
    });
  }
};

export const getLatestJackpotResultByDraw = (gameId: number) => async (dispatch: any) => {
  try {
    dispatch({
      type: REQUEST('GET_LATEST_RESULTS_FOR_DRAW'),
      payload: null
    });
    const response = await GamesService.getLatestJackpotResultByGame(gameId);
    dispatch({
      type: SUCCESS('GET_LATEST_RESULTS_FOR_DRAW'),
      payload: response
    });
  } catch (error: any) {
    dispatch({
      type: FAILURE('GET_LATEST_RESULTS_FOR_DRAW'),
      payload: error.payload ? error.payload : error
    });
  }
};

export const sendPlayerTicketDataForJackpot = (
  gameId: number,
  drawId: string,
  playerSpots: any[],
  ticketCost: number,
  callbackFunc?: (args: any) => void
) => async (dispatch: any) => {
  try {
    const response = await GamesService.sendPlayerTicketDataForJackpotGame(gameId, drawId, playerSpots, ticketCost);
    const data = {
      payout: response.payout ? response.payout.value : null,
      ticketEntryNumbers: response.gameNumbers,
      multiplier: response.jackpotResult ? response.jackpotResult.multiplier : null
    };
    if (callbackFunc) {
      callbackFunc(data);
    }

    dispatch({
      type: SEND_PLAYERS_DATA_FOR_JACKPOT,
      payload: Promise.resolve(response)
    });
  } catch (error) {
    if (callbackFunc) {
      callbackFunc(error);
    }
  }
};

export const getMultipleDrawsPayout = (
  gameId: number,
  drawIds: string[],
  playerSpots: any[],
  ticketCost: number,
  callbackFunc?: (args: any) => void
) => async (dispatch: any) => {
  try {
    const response = await GamesService.getMultipleDrawsPayout(gameId, drawIds, playerSpots, ticketCost);
    const data = response.map(item => ({
      payout: item.payout ? item.payout.value : null,
      ticketEntryNumbers: item.gameNumbers,
      multiplier: item.jackpotResult ? item.jackpotResult.multiplier : null,
      drawId: item.jackpotResult ? item.jackpotResult.externalId : null,
      matches: playerSpots.filter(number => item.gameNumbers.includes(parseInt(number, 10))).length,
      jackpotStatus: item.jackpotResult ? item.jackpotResult.jackpotStatus : null
    }));

    if (callbackFunc) {
      callbackFunc(data);
    }

    dispatch({
      type: GET_JACKPOT_PAYOUT_FOR_DRAWS,
      payload: Promise.resolve(response)
    });
  } catch (error) {
    if (callbackFunc) {
      callbackFunc(error);
    }
  }
};

export const resetJackpot = () => (dispatch: any) => {
  dispatch({
    type: 'RESET_JACKPOT',
    payload: null
  });
};

export const resetJackpotError = () => (dispatch: any) => {
  dispatch({
    type: 'RESET_JACKPOT_ERROR',
    payload: null
  });
};
